import type { ReactNode } from 'react'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { cn } from '@/lib/utils'

import type { SelectableMember } from './add-participant-member-list.molecule'
import { AddParticipantMemberList } from './add-participant-member-list.molecule'

export interface AddParticipantDialogProps {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  memberList: SelectableMember[]
  onMemberSelect: (userId: string) => void
  isLoading?: boolean
  className?: string
}

/**
 * Dialog for adding a team member to a conversation.
 * Displays a searchable list of available organization members.
 */
export const AddParticipantDialog: React.FC<AddParticipantDialogProps> = ({
  isOpen,
  onOpenChange,
  memberList,
  onMemberSelect,
  isLoading = false,
  className,
}): ReactNode => (
  <Dialog open={isOpen} onOpenChange={onOpenChange}>
    <DialogContent className={cn('add-participant-dialog sm:max-w-md p-0', className)}>
      <DialogHeader className="px-4 pt-4">
        <DialogTitle className="add-participant-dialog-title">Add Participant</DialogTitle>
        <DialogDescription className="add-participant-dialog-description">
          Select a team member to add to this conversation.
        </DialogDescription>
      </DialogHeader>
      <AddParticipantMemberList
        memberList={memberList}
        onMemberSelect={onMemberSelect}
        isLoading={isLoading}
      />
    </DialogContent>
  </Dialog>
)

AddParticipantDialog.displayName = 'AddParticipantDialog'
